import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent, reactive, ref, watch } from "vue";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import useCurrentInstance from "@/hooks/useCurrentInstance";
export default defineComponent({
  props: {
    title: {
      type: String,
      default: "选择审批人员"
    },
    errorTips: {
      type: String,
      default: "请选择审批人"
    }
  },
  emits: ["approvalPepole"],
  setup: function setup(props, context) {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var dialogVisible = ref(false);
    var userName = ref("");
    var radioVal = ref();
    var initRadioVal = ref(); //获取审批列表

    var Data = reactive({
      detail: [{
        approveId: '',
        approveName: ''
      }],
      personalList: [],
      tabsAcitve: ""
    });

    function getapproveListw(_x) {
      return _getapproveListw.apply(this, arguments);
    }

    function _getapproveListw() {
      _getapproveListw = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(approveId) {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["approveListw"]({
                  flag: 1,
                  pageIndex: 1,
                  pageSize: 1000
                });

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                Data.detail = data;
                Data.tabsAcitve = approveId ? String(approveId) : "1";

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getapproveListw.apply(this, arguments);
    }

    function getapproveUserListw(_x2) {
      return _getapproveUserListw.apply(this, arguments);
    }

    function _getapproveUserListw() {
      _getapproveUserListw = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item) {
        var _yield$globalProperti2, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Data.personalList = [];
                _context2.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["approveUserListw"]({
                  approveId: item
                });

              case 3:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                Data.personalList = data;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getapproveUserListw.apply(this, arguments);
    }

    var select = function select(item) {
      getapproveListw(item.radioVal.orgId); // radioVal.value = Number(radioVal.value) + 1;

      radioVal.value = item.radioVal.id;
      initRadioVal.value = item.radioVal.id;
      dialogVisible.value = item.dialogVisible || false;
    };

    var submit = function submit() {
      if (radioVal.value == "") {
        ElMessage(props.errorTips);
      } else {
        dialogVisible.value = false;

        if (initRadioVal.value != radioVal.value) {
          context.emit("approvalPepole", {
            id: radioVal.value,
            orgId: Data.tabsAcitve,
            name: userName.value
          });
        }
      }
    };

    function change(userId) {
      var row = Data.personalList.find(function (item) {
        return item.userId == userId;
      });
      userName.value = row.username;
    }

    watch(function () {
      return Data.tabsAcitve;
    }, function (v) {
      if (v) {
        getapproveUserListw(v);
      }
    });
    return {
      getapproveListw: getapproveListw,
      getapproveUserListw: getapproveUserListw,
      change: change,
      Data: Data,
      dialogVisible: dialogVisible,
      submit: submit,
      radioVal: radioVal,
      select: select
    };
  }
});